import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class ReceiptService {
  constructor(private http: HttpUtilService) {}

  getTerminalList(): Observable<any> {
    return this.http.get(`/SalesmanReceiptService.asmx/GetTerminalList`);
  }

  getReceiptBySearch(searchText: string, searchOption: string): Observable<any> {
    const url = `/ReceiptService.asmx/Search?searchOption=%22${searchOption}%22&searchText=%22${searchText}%22`;
    return this.http.get(url);
  }

  getLastReceiptNo(): Observable<any> {
    return this.http.get('/ReceiptService.asmx/GetLastReceiptNo');
  }

  addReceipt(payload: any): Observable<any> {
    return this.http.post('/ReceiptService.asmx/AddReceipt', { model: payload });
  }

  updateReceipt(payload: any): Observable<any> {
    return this.http.post('/ReceiptService.asmx/UpdateReceipt', { model: payload });
  }

  deleteReceipt(receiptNo: string, deleteRemarks: string): Observable<any> {
    return this.http.post('/ReceiptService.asmx/DeleteReceipt', {
      receiptNo,
      deleteRemarks
    });
  }

  printReceipt(receiptNo: string): Observable<any> {
    return this.http.post('/ReceiptService.asmx/Print', {
      model: { Name: 'ReceiptNo', Value: receiptNo }
    });
  }

  sendReceiptEmail(receiptNo: string): Observable<any> {
    return this.http.post('/ReceiptService.asmx/SendMail', {
      model: { Name: 'ReceiptNo', Value: receiptNo }
    });
  }

  transferReceipt(model: {
    ReceiptNo: string;
    TransferContractNo: string;
    TransferRemarks: string;
  }): Observable<any> {
    return this.http.post('/ReceiptService.asmx/TransferReceipt', { model });
  }
  
  searchDeposit(searchText: string, searchOption: string): Observable<any> {
    const url = `/ReceiptService.asmx/SearchDeposit?searchOption=%22${searchOption}%22&searchText=%22${searchText}%22`;
    return this.http.get(url);
  }
  
}
